import { useMemo } from 'react';
import useWhyBuyData from './useWhyBuyData';

export type WhyBuyNarrativeItem = {
  content: string;
  id: string;
  title: string;
};

export default function useWhyBuyNarratives(): Array<WhyBuyNarrativeItem> {
  const { bulletPoints } = useWhyBuyData();

  return useMemo(
    () =>
      (bulletPoints ?? []).flatMap(({ content, title }, index) =>
        content && title
          ? [{ content, id: `why-buy-narrative-${index}`, title }]
          : []
      ),
    [bulletPoints]
  );
}
